// extracted by mini-css-extract-plugin
export default {"back":"termsAndPolicy_back__QT00L","privacy":"termsAndPolicy_privacy__vVRMG"};